import { Link } from 'react-router-dom';
import { Button } from '../../../components/base/Button';

export const HeroSection = () => {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image with Overlay */}
      <div 
        className="absolute inset-0 z-0"
        style={{
          backgroundImage: `url('https://public.readdy.ai/ai/img_res/ddb8696d836b0960dc72b172a32e7b0b.jpg')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat'
        }}
      >
        <div className="absolute inset-0 gradient-overlay"></div>
      </div>

      {/* Content */}
      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-4xl mx-auto text-center text-white animate-fade-in">
          <div className="mb-6 inline-block">
            <div className="w-20 h-20 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center mx-auto animate-float">
              <i className="ri-heart-pulse-line text-5xl text-white"></i>
            </div>
          </div>
          
          <h2 className="text-5xl md:text-6xl lg:text-7xl font-bold mb-6 leading-tight">
            نساعدك على الإقلاع بأمان
          </h2>
          
          <p className="text-xl md:text-2xl mb-8 text-white/95 leading-relaxed max-w-3xl mx-auto">
            بخدمات طبية مجانية ومعتمدة من <strong>جمعية مكافحة التدخين بالأفلاج</strong>
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <Link to="/consultation">
              <Button variant="accent" size="lg" pulse icon="ri-calendar-check-line">
                ابدأ طلب استشارة
              </Button>
            </Link>
            <Link to="/services">
              <Button variant="outline" size="lg" icon="ri-service-line" className="bg-white/10 backdrop-blur-sm border-white text-white hover:bg-white hover:text-primary">
                تعرف على خدماتنا
              </Button>
            </Link>
          </div>

          {/* Stats */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mt-16 max-w-4xl mx-auto">
            {[
              { number: '500+', label: 'مريض' },
              { number: '95%', label: 'نسبة النجاح' },
              { number: '5+', label: 'سنوات خبرة' },
              { number: '1000+', label: 'جلسة علاجية' },
            ].map((stat, index) => (
              <div key={index} className="bg-white/10 backdrop-blur-sm rounded-xl p-6 animate-slide-up" style={{ animationDelay: `${index * 0.1}s` }}>
                <div className="text-3xl md:text-4xl font-bold text-accent mb-2">{stat.number}</div>
                <div className="text-sm md:text-base text-white/90">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10 animate-bounce">
        <i className="ri-arrow-down-line text-white text-3xl"></i>
      </div>
    </section>
  );
};